import { render } from "./EduListRegisterPage.vue?vue&type=template&id=1bc951b0"
import script from "./EduListRegisterPage.vue?vue&type=script&lang=js"
export * from "./EduListRegisterPage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/hooeni/Workspace/eduwind-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__